import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { MatCard } from '@angular/material/card';
import { ConfigurableBundleTemplateModel } from '@libs/shop/models';

@Component({
  selector: 'ui-configurable-bundle-form-banner',
  imports: [
    MatCard,
  ],
  templateUrl: './configurable-bundle-form-banner.component.html',
  styleUrl: './configurable-bundle-form-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfigurableBundleFormBannerComponent {
  public bundleTemplate: InputSignal<ConfigurableBundleTemplateModel> = input.required();
}
